export default __webpack_public_path__ + "banner-message-error-icon.90ed761748c56e04050f.png";